const DateFormat = (timestamp) => {
  const date = new Date(timestamp); // Create a new Date object with the current date and time
  const options = { year: "numeric", month: "long", day: "numeric" }; // Define the options for formatting the date
  const formattedDate = date.toLocaleDateString(undefined, options); // Format the date using toLocaleDateString()
  return formattedDate;
};
export default DateFormat;
